/* eslint-disable eol-last */
import request from '@/utils/home/tagging'
// 预生码管理界面readycreate
export function readycreatelist(query) {
  return request({
    url: '/api/produce/qrcode/query',
    method: 'get',
    params: query
  })
}
export function readycreateupdate(data) {
  return request({
    url: '/api/produce/qrcode/update',
    method: 'post',
    data
  })
}
export function readycreateadd(data) {
  return request({
    url: '/api/produce/qrcode/add',
    method: 'post',
    data
  })
}
export function readycreatedelete(data) {
  return request({
    url: '/api/produce/qrcode/del',
    method: 'post',
    data
  })
}
export function readycreatebuild(data) {
  return request({
    url: '/api/produce/qrcode/build',
    method: 'post',
    data
  })
}

export function getcodefilepath(data) {
  return request({
    url: '/api/produce/buidcode/getcodefilepath',
    method: 'post',
    data
  })
}
export function rulenewsquery(query) {
  return request({
    url: '/api/produce/qrcode/rulequery',
    method: 'get',
    params: query
  })
}
export function neworderno(query) {
  return request({
    url: '/api/produce/qrcode/neworderno',
    method: 'get',
    params: query
  })
}
export function updateclose(data) {
  return request({
    url: '/api/produce/qrcode/updateclose',
    method: 'post',
    data
  })
}
// 以生码查询
export function complete(query) {
  return request({
    url: '/api/produce/qrcode/complete',
    method: 'get',
    params: query
  })
}
export function downpack(data) {
  return request({
    url: '/api/produce/qrcode/downpack',
    method: 'post',
    data
  })
}

// 工厂下拉集合
export function outfactorylist(data) {
  return request({
    url: '/api/produce/factory/list',
    method: 'post',
    data
  })
}
// 生码查询表
export function getlist(query) {
  return request({
    url: '/api/produce/qrcodebuild/getlist',
    method: 'get',
    params: query
  })
}
// 已关闭订单查询
export function queryclose(query) {
  return request({
    url: '/api/produce/qrcodebuild/queryclose',
    method: 'get',
    params: query
  })
}
// 生码查询表
export function codeinputlist(query) {
  return request({
    url: '/api/produce/qrcodetask/list',
    method: 'get',
    params: query
  })
}
// 生码规则
// 查询生码规则
export function findmaster(query) {
  return request({
    url: '/api/produce/qrcoderule/findmaster',
    method: 'get',
    params: query
  })
}
// 模糊查询生码规则
export function FuzzyQuery(query) {
  return request({
    url: '/api/produce/qrcode/FuzzyQuery',
    method: 'get',
    params: query
  })
}
// 查询生码规则明细
export function finddetail(query) {
  return request({
    url: '/api/produce/qrcoderule/finddetail',
    method: 'get',
    params: query
  })
}
// 生码规则删除
export function codedelete(query) {
  return request({
    url: '/api/produce/qrcoderule/delete',
    method: 'get',
    params: query
  })
}
// 新增生码规则
export function codeadd(data) {
  return request({
    url: '/api/produce/qrcoderule/add',
    method: 'post',
    data
  })
}
// 新增生码规则
export function codeupdate(data) {
  return request({
    url: '/api/produce/qrcoderule/update',
    method: 'post',
    data
  })
}
// 获取链接url
export function geturl(query) {
  return request({
    url: '/api/produce/qrcoderule/geturl',
    method: 'get',
    params: query
  })
}
// 查询原料投料信息分页列表
export function MaterialsBatchLogPagelist(query) {
  return request({
    url: '/api/produce/mterialsbatchlog/pagelist',
    method: 'get',
    params: query
  })
}